var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForummLogo = function SvgForummLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ForummLogo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.45 183.45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ForummLogo_svg__cls-2{fill:#42efcc}.ForummLogo_svg__cls-4{fill:#49caf4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ForummLogo_svg__cls-2",
    d: "M91.72 114v20.41c-30.35 0-55-23.93-55-53.44a52.74 52.74 0 0 1 1-10.2C42.66 95.37 65 114 91.72 114ZM146.69 80.94v1.63c-1.17 49.17-54.94 72.22-54.94 72.22v-20.41s47.06-20.17 54.08-63a52.31 52.31 0 0 1 .86 9.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.06 61.81C130.8 97.22 91.72 114 91.72 114V93.57a55 55 0 0 1-50.81-33 55 55 0 0 1 50.81-33c23.42-.07 43.43 14.18 51.34 34.24Z",
    style: {
      fill: "#2564f2"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ForummLogo_svg__cls-4",
    d: "M91.72 93.57V114c-26.76 0-49.06-18.6-54-43.23a52.48 52.48 0 0 1 3.15-10.2 55 55 0 0 0 50.85 33ZM145.8 71.35c-7 42.86-54.08 63-54.08 63V114s39.08-16.75 51.34-52.16a51.75 51.75 0 0 1 2.74 9.51Z"
  })));
};
export default SvgForummLogo;